import { PublicNode, SearchNodeTerm } from '../../__generated__/api'

export const flattenNodes = (nodes: PublicNode[]): PublicNode[] =>
  nodes.reduce((acc: PublicNode[], node: PublicNode) => {
    if (node.children) {
      const childrenResults = flattenNodes(node.children)
      childrenResults.forEach((childNode) => acc.push(childNode))
    }
    acc.push(node)
    return acc
  }, [])

export const flattenTerms = (nodes: PublicNode[]): SearchNodeTerm[] =>
  nodes.reduce((acc: SearchNodeTerm[], node: PublicNode) => {
    if (node.children) {
      const childrenResults = flattenTerms(node.children)
      acc.push(...childrenResults)
    }
    node.connections?.forEach((connection) => {
      if (Array.isArray(connection.terms)) {
        acc.push(...connection.terms)
      }
    })
    return acc
  }, [])
